export default __webpack_public_path__ + "static/media/blog01.b78a3618.png";